export default "__VITE_ASSET__cc43e685__"